import { toast } from 'react-toastify';
import { Response } from '../interface';

function generateHeader(object: any = {}): any {
    const header: { [k: string]: any } = {};
    for (const key of Object.keys(object)) {
        header[key] = object[key];
    }
    return header;
}

// get request
export function _get<R>(url: string, params: { [k: string]: any } = {}): Promise<Response<R>> {
    const generatedUrl = new URL(url);
    // add query parameters like filters or pagination parameters
    Object.keys(params).forEach((key) => {
        generatedUrl.searchParams.append(key, params[key]);
    });
    let status: number;
    return new Promise((resolve, reject) => {
        fetch(generatedUrl.href, {
            method: 'GET',
            headers: generateHeader({ 'Content-Type': 'application/json' }),
        })
            .then(function (response) {
                status = response.status;
                return response.json();
            })
            .then(function (data) {
                if (responseValidator(status)) resolve({ value: data, status });
                else {
                    toast.error(data.message);
                    reject({ data, status });
                }
            })
            .catch((/* err */) => {
                reject({ data: null, status });
            });
    });
}

function responseValidator(status: number): boolean {
    return status >= 200 && status < 300;
}
